import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.scss']
})
export class DisclaimerComponent implements OnInit {
  Company_Name = "";
  // Platform_Name = ""
  App_Name = ""
  Website_URL = ""

  constructor() { }

  ngOnInit() {
    this.Company_Name = sessionStorage.getItem('ihjt45h45=CompanyName')
    this.App_Name = sessionStorage.getItem('lkighty445dh==AppName')
    // this.Platform_Name = this.Company_Name
    this.Website_URL = window.location.pathname
  }

}
